<template>
  <main id="main">
    <div class="container">
      <header class="header">
        <a href="https://www.cna.com.br">
          <div class="logo">
            <img
              src="https://www.cna.com.br/wp-content/uploads/2024/08/logo-cna-idiomas-color.webp"
              alt="Logo CNA"
            />
          </div>
        </a>
      </header>
      <!--Começo Cadastro-->
      <section v-if="!sucesso && !carregando" id="cadastro" class="row">
        <div class="col-12">
          <span
            class="subtitle text-center"
          >{{ result.statusAcaoComercialId == 1 ? result.nomeEscola.toUpperCase() : 'Ops!' }}</span>
          <span
            class="title text-center"
          >{{ result.statusAcaoComercialId == 1 ? result.descricao : 'Esta promoção já se encerrou,' }}</span>
          <span
            class="title-2 text-center"
          >{{ result.statusAcaoComercialId == 1 ? '' : 'mas não se preocupe. Se deseja que o CNA entre em contato com você, preencha o formulário abaixo:' }}</span>
          <form
            class="form lazy-recaptcha"
            data-recaptcha="form"
            ref="frmCadastro"
            method="post"
            action
            novalidate
          >
            <div class="row">
              <div class="col-12">
                <label class="form_label">
                  <input
                    type="text"
                    class="form_input"
                    v-model="model.nome"
                    name="Name"
                    placeholder="Nome e Sobrenome"
                    required
                    maxlength="40"
                  />
                  <div class="invalid-feedback">Por favor preencher Nome e Sobrenome</div>
                </label>
              </div>
              <div class="col-12">
                <div class="form_contact">
                  <span class="lbl-title">Eu concordo em receber contato do CNA por meio de:</span>

                  <label class="custom-control custom-checkbox lbl-check">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="model.aceitaEmail"
                      role="button"
                    />
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">E-mail</span>
                  </label>

                  <label class="custom-control custom-checkbox lbl-check">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="model.aceitaWhatsApp"
                      role="button"
                    />
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">WhatsApp</span>
                  </label>

                  <label class="custom-control custom-checkbox lbl-check">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="model.aceitaTelefone"
                      role="button"
                    />
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">Telefone</span>
                  </label>

                  <label class="custom-control custom-checkbox lbl-check">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="model.aceitaSMS"
                      role="button"
                    />
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">SMS</span>
                  </label>
                </div>
              </div>
              <div class="col-12" v-if="model.aceitaEmail">
                <label class="form_label">
                  <input
                    type="email"
                    class="form_input email"
                    name="Email"
                    id="schoolEmail"
                    placeholder="E-mail"
                    data-email
                    :required="model.aceitaEmail"
                    v-model="model.email"
                  />
                  <div class="invalid-feedback">Por favor preencher o Email</div>
                </label>
              </div>
              <div
                class="col-12"
                v-if="model.aceitaWhatsApp || model.aceitaTelefone || model.aceitaSMS"
              >
                <label class="form_label">
                  <input
                    type="text"
                    class="form_input phone"
                    name="Whatsapp"
                    v-model="model.telefone"
                    placeholder="Telefone"
                    :required="model.aceitaWhatsApp || model.aceitaTelefone || model.aceitaSMS"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                  />
                  <div class="invalid-feedback">Por favor preencher o Telefone</div>
                </label>
              </div>
              <div class="col-12">
                <label class="custom-control custom-checkbox lbl-privacy">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    v-model="checkedMaiorIdade"
                    role="button"
                  />
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-description">Declaro ser maior de 18 anos.</span>
                </label>
              </div>
              <div class="col-12">
                <label class="custom-control custom-checkbox lbl-privacy">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    v-model="checkedConsentimento"
                    role="button"
                  />
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-description">
                    Consinto no tratamento dos meus dados pessoais conforme
                    <a
                      href="https://www.cna.com.br/politica-de-privacidade"
                    >Política de Privacidade</a> do CNA.
                  </span>
                </label>
              </div>
              <div class="col-12 d-flex flex-column align-items-center">
                <button
                  type="button"
                  class="button"
                  v-bind:disabled="!checkedMaiorIdade || !checkedConsentimento || !(this.model.aceitaEmail || this.model.aceitaSMS || this.model.aceitaTelefone || this.model.aceitaWhatsApp)"
                  @click="cadastrar()"
                >CADASTRAR</button>
              </div>
              <div class="col-12 col-md-12">
                <span class="form-privacy right">
                  O CNA respeita a sua privacidade e protege seus dados pessoais conforme nossa
                  <a
                    href="https://www.cna.com.br/politica-de-privacidade"
                  >Política de Privacidade</a>
                </span>
              </div>
            </div>
          </form>
        </div>
      </section>
      <!--Fim Cadastro-->
      <!--Inicio mensagem de sucesso Cadastro-->
      <section v-if="sucesso && !carregando" id="msg-envio-sucesso" class="row">
        <div class="col-12">
          <span
            class="subtitle text-center"
            style="font-size: 27px;"
          >{{ result.statusAcaoComercialId == 1 ? 'Boa sorte!' : 'Seu Cadastro foi realizado com sucesso.' }}</span>
          <span
            class="title text-center"
          >{{ result.statusAcaoComercialId == 1 ? 'Seu cadastro foi realizado com sucesso.' : 'Em breve, um dos nossos consultores entrará em contato.' }}</span>

          <div class="row" style="margin-bottom: 40px;">
            <div class="col-12" style="margin-top: 10px; text-align: center; font-size: 18px;">
              <label class="lbl-privacy" style="color: #484848;">
                <span
                  style
                >Aproveite para ler, no Blog CNA, algumas dicas de como aprender um novo idioma e saia na frente.</span>
              </label>
            </div>
          </div>
        </div>

        <div class="col-lg-12 text-center">
          <div class="post">
            <h2 class="post_title">
              <a
                v-bind:href="itemInfo.Url"
                style="text-decoration: none; color: #484848;"
              >{{ itemInfo.Titulo }}</a>
            </h2>
            <a v-bind:href="itemInfo.Url">
              <figure class="post_figure mx-auto">
                <img class="img-fluid mx-auto" v-bind:src="itemInfo.LinkImagem" />
              </figure>
            </a>
            <p
              class="post_preview"
              style="color: #484848;"
            >Existe um consenso sobre a idade ideal para aprender inglês? Não exatamente porque a idade é apenas um dos fatores que podem influenciar o aprendizado</p>
            <div class="d-flex flex-row flex-wrap justify-content-between">
              <a :href="itemInfo.Url" class="btn button button-white" type="submit">CONTINUE LENDO</a>

              <a
                href="https://www.cna.com.br/blog"
                class="btn button"
              >LEIA OUTROS ARTIGOS NO BLOG CNA</a>
            </div>
          </div>
        </div>
      </section>
      <section v-if="carregando" id="msg-envio-sucesso" class="row">
        <div class="col-12 text-center">
          Carregando... Aguarde...
        </div>
      </section>
      <!--Fim mensagem de sucesso Cadastro-->
    </div>
  </main>
</template>
<script>
import base from '@/common/base'
import { Api } from '@/common/api'
import { mask } from 'vue-the-mask'

export default {
  name: 'acaocomercial_cadastro',
  mixins: [base],
  components: {},
  directives: { mask },
  data() {
    return {
      itemInfo: {},
      model: {
        aceitaEmail: false,
        aceitaWhatsApp: false,
        aceitaTelefone: false,
        aceitaSMS: false,
        email: null,
        telefone: null
      },
      checkedMaiorIdade: false,
      checkedConsentimento: false,
      sucesso: false,
      expirada: false,
      carregando: true,
      result: {
        nomeEscola: ''
      },
      regexEmail: /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/
    }
  },
  methods: {
    async cadastrar() {
      try {

        if (!(this.model.aceitaEmail || this.model.aceitaSMS || this.model.aceitaTelefone || this.model.aceitaWhatsApp)) {
          this.defaultErrorResult("Por favor selecione ao menos uma forma de contato!!!!")
          return
        }

        if (this.model.aceitaEmail && !this.regexEmail.test(this.model.email))
        {
          this.defaultErrorResult('Por favor verifique se o email está digitado corretamente!!!')
          return;
        }

        if (this.model.aceitaEmail && this.model.email.indexOf('@cna') > -1)
        {
          this.defaultErrorResult('E-mail\'s domínio @CNA não são aceitos neste campo!!!')
          return;
        }

        if (this.formValidate() == false)
          return;

        this.model.token = await this.$recaptcha('login')
        this.model.acaoComercialId = this.result.acaoComercialId
        this.model.acaoExpirada = this.result.statusAcaoComercialId !== 1

        this.showLoading()
        new Api('acaocomercialcadastro/SalvarAcaoComercialCadastro').post(this.model)
          .then(() => {
            this.blog()
            this.sucesso = true
            this.carregando = false
            this.hideLoading()
          }).catch(err => {
            this.defaultErrorResult(err)
            this.hideLoading()
          })
      } catch (e) {
        console.log(e)
      }
    },

    formValidate: function () {
      var $form = this.$refs.frmCadastro;
      $form.classList.add("was-validated");
      return $form.checkValidity();
    },

    blog() {
      fetch('https://www.cna.com.br/api/blogposts')
        .then(async data => this.itemInfo = await data.json())
        .catch(e =>
          console.error('Boo...' + e));
    },

    async verificaAcaoComercial() {
      this.showLoading()
      const acaoComercialExternalHash = this.$route.params.id

      console.log(acaoComercialExternalHash)
      if (!acaoComercialExternalHash) {
        this.$router.push({ path: '/404', replace: true })
        return;
      }

      try {
        const data = await new Api('acaocomercial/localizaacaocomercial').get({ acaoComercialExternalHash: acaoComercialExternalHash });
        console.log(data)
        if (data.data) {
          this.result = data.data
          this.carregando = false
        }
        else {
          this.$router.push({ path: '/404', replace: true })
        }
      }
      catch (err) {
        this.$router.push({ path: '/404', replace: true })
      }
      finally {
        this.hideLoading()
        this.carregando = false
      }
      
    }

  },
  mounted() {

  },
  created() {
    this.verificaAcaoComercial()
  }
}
</script>
<style scoped lang="scss">
.subtitle {
  color: #db2949;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 2px;
  font-weight: 700;
  display: block;
  margin: 0;
  padding: 0;
}

.title {
  color: #484848;
  font-size: 40px;
  line-height: 52px;
  font-weight: 700;
  display: block;
  margin: 0 0 0px;
  padding: 0;
}

.title-2 {
  color: #484848;
  font-size: 20px;
  line-height: 20px;
  font-weight: 500;
  display: block;
  margin: 0 0 30px;
  padding: 0;
}

.form_label {
  position: relative;
  display: block;
  background: #fff;
  border-radius: 4px;
  margin: 0 0 15px;
  font-size: 15px;
  font-weight: 400;
  line-height: 30px;
  color: #8290a7;

  .form_input {
    height: 43px;
    background-color: #f2f2f2;
    border: 1px solid #fff;
    border-radius: 4px;
    width: 100%;
    padding: 0 15px;
    font-size: 14px;
    color: #484848;
  }
}

.form_contact {
  margin: 0 0 10px;

  .lbl-title {
    display: block;
    color: #484848;
    font-size: 14px;
    font-weight: 700;
    margin: 10px 0;
  }

  .lbl-check {
    color: #484848;
    font-size: 12px;
    font-weight: 400;
    display: inline-flex;
    align-items: center;

    & + .lbl-check {
      margin-left: 4px;
    }

    input {
      margin: 0 4px 0 0;
    }
  }

  .preferencial-msg {
    /* display: none; */
    color: red;
    font-size: 12px;
    font-weight: 400;
  }
}

.lbl-privacy {
  line-height: 14px;
  color: #484848;
  font-size: 12px;
  font-weight: 400;
  position: relative;

  & > a {
    color: #484848;
    text-decoration: underline;
  }
}

.form-privacy {
  color: #484848;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  display: block;
  margin: 10px 0;

  @media (min-width: 768px) {
    margin: 85px 0 0;
    clear: both;
    text-align: right;
  }
}

.button {
  height: 50px;
  width: 400px;
  margin-top: 20px;
  font-weight: 600;
  font-size: 14px;
  line-height: 50px;
  letter-spacing: 2px;
  color: #fff;
  background: #e22347;
  border: 1px solid #e22347;
  padding: 0 15px;
  display: block;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  border-radius: 4px;

  @media (max-width: 575px) {
    width: 100%;
    margin-top: 30px;
  }

  &:hover {
    background: #e3e3e3;
    border-color: #e3e3e3;
    color: #e22347;
  }

  &:disabled {
    filter: grayscale(0.5);
    opacity: 0.7;
  }
}

.post {
  .post_title {
    color: #484848;
    font-size: 28px;
    font-weight: 700;
    line-height: 36px;
    margin: 0 0 15px;
    padding: 0;
  }

  .post_figure {
    display: block;
    margin: 0 0 30px;
    text-decoration: none;
    text-align: center;
  }

  .post_preview {
    color: #8b8b8b;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    margin: 0 0 15px;
    padding: 0;
  }

  .button-white {
    color: #e22347;
    background: #fff;

    &:hover {
      background: #e3e3e3;
      border-color: #e3e3e3;
      color: #e22347;
    }
  }

  .button {
    min-width: 220px;
    margin: 0 0 30px;
  }
}

#main {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-variant-numeric: lining-nums;

  .header {
    position: relative;
    z-index: 9;
    height: 170px;

    .logo {
      width: 218px;
      height: 218px;
      border-radius: 50%;
      display: inline-block;
      vertical-align: top;
      background: #fff;
      filter: drop-shadow(0px 3px 6px rgba(23, 23, 23, 0.25));
      margin: 0 0 0 -109px;
      text-decoration: none;
      position: absolute;
      left: 50%;
      //top: -90px;
      z-index: 999;
      transition: top 0.3s ease;

      img {
        display: block;
        height: 61px;
        width: 151px;
        margin: 104px auto 0;
        transition: all 0.3s ease;
      }
    }
  }
}
</style>